export const spdrDefaultValues = {
  Id: 0,
  PlantGsdb: "",
  SupplierGsdb: "",
  DockCode: "",
  CMMS3TransitTime: 0,
  CMMS3ShipFrequency: 0,
  PartExceptionRequired: false,
  InScope: false,
  InboundMegaLdm: 0,
  InboundEuroLdm: 0,
  InboundKg: 0,
  InboundCubicMeters: 0,
  InboundMissingPackagePercent: 0,
  NumberOfParts: 0,
  ShipIndicator: "",
  ReturnMegaLdm: 0,
  ReturnEuroLdm: 0,
  ReturnWeight: 0,
  ReturnCubicMeters: 0,
};
